import { createContext } from 'react';

const FormModalContext = createContext();

export default FormModalContext;
